/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/generate-component-factory.js to modify the generation of this file.
import AccordionComponent from '../components/Accordion-Component';
import AccordionModuleComponent from '../components/Accordion-Module-Component';
import AccordionSectionComponent from '../components/Accordion-Section-Component';
import ActivitiesCardComponent from '../components/Activities-Card-Component';
import Article from '../components/Article';
import ArticleCardComponent from '../components/Article-Card-Component';
import ArticleList from '../components/Article-List';
import BaseFormComponent from '../components/Base-Form-Component';
import BasicCardBorder from '../components/Basic-Card-Border';
import BasicCardCircle from '../components/Basic-Card-Circle';
import BasicCardParenthesis from '../components/Basic-Card-Parenthesis';
import BasicCardRoundCorners from '../components/Basic-Card-Round-Corners';
import BasicParenthesisSection from '../components/Basic-Parenthesis-Section';
import BasicPillBoxSection from '../components/Basic-Pill-Box-Section';
import BasicSingleColumnComponent from '../components/Basic-Single-Column-Component';
import BasicTwoColumnSection from '../components/Basic-Two-Column-Section';
import BreadcrumbsComponent from '../components/Breadcrumbs-Component';
import BroadstreetAdStaticComponent from '../components/Broadstreet-Ad-Static-Component';
import BuildingNavigatorComponent from '../components/Building-Navigator-Component';
import CampusViewComponent from '../components/Campus-View-Component';
import CarouselComponent from '../components/Carousel-Component';
import ChannelPreferenceCenterComponent from '../components/Channel-Preference-Center-Component';
import ChannelSelectorComponent from '../components/Channel-Selector-Component';
import CompanyNavigation from '../components/Company-Navigation';
import ContentBreakerComponent from '../components/Content-Breaker-Component';
import ContentSectionComponent from '../components/Content-Section-Component';
import ContentSectionWithBackgroundColor from '../components/Content-Section-With-Background-Color';
import ContentSectionWithImageBackground from '../components/Content-Section-With-Image-Background';
import DefineSearchIntent from '../components/Define-Search-Intent';
import DigitalCatalog from '../components/Digital-Catalog';
import DigitalShowroomCatalogsList from '../components/Digital-Showroom-Catalogs-List';
import DigitalShowroomCatalogsOverview from '../components/Digital-Showroom-Catalogs-Overview';
import DigitalShowroomContactInformation from '../components/Digital-Showroom-Contact-Information';
import DigitalShowroomEventsList from '../components/Digital-Showroom-Events-List';
import DigitalShowroomEventsOverview from '../components/Digital-Showroom-Events-Overview';
import DigitalShowroomInfo from '../components/Digital-Showroom-Info';
import DigitalShowroomLinesList from '../components/Digital-Showroom-Lines-List';
import DigitalShowroomLinesOverview from '../components/Digital-Showroom-Lines-Overview';
import DigitalShowroomProductDetail from '../components/Digital-Showroom-Product-Detail';
import DigitalShowroomProductsList from '../components/Digital-Showroom-Products-List';
import DigitalShowroomProductsOverview from '../components/Digital-Showroom-Products-Overview';
import DigitalShowroomSpecials from '../components/Digital-Showroom-Specials';
import DigitalShowroomSpecialsOverview from '../components/Digital-Showroom-Specials-Overview';
import DigitalTab from '../components/Digital-Tab';
import DigitalTabbedNavigationComponent from '../components/Digital-Tabbed-Navigation-Component';
import DiningGuide from '../components/Dining-Guide';
import EventDetail from '../components/Event-Detail';
import EventList from '../components/Event-List';
import EventRegistrationFormForIMCEvents from '../components/Event-Registration-Form-For-IMC-Events';
import ExhibitedOnFloor from '../components/Exhibited-On-Floor';
import ExhibitorAdComponent from '../components/Exhibitor-Ad-Component';
import ExhibitorAZDirectory from '../components/Exhibitor-AZ-Directory';
import ExtendedTooltip from '../components/ExtendedTooltip';
import FeaturedArticles from '../components/Featured-Articles';
import FeaturedEvents from '../components/Featured-Events';
import FilterBarComponent from '../components/Filter-Bar-Component';
import FilterOptions from '../components/Filter-Options';
import FilterSearchByLetter from '../components/Filter-Search-By-Letter';
import FlexGrid from '../components/Flex-Grid';
import FlexSection from '../components/Flex-Section';
import FloorPlanComponent from '../components/Floor-Plan-Component';
import FooterFlags from '../components/Footer-Flags';
import FooterNavigationComponent from '../components/Footer-Navigation-Component';
import GlobalHeaderContainer from '../components/Global-Header-Container';
import GridColumnComponent from '../components/Grid-Column-Component';
import GridComponent from '../components/Grid-Component';
import HeaderNavigationComponent from '../components/Header-Navigation-Component';
import HeaderNavigationMobileComponent from '../components/Header-Navigation-Mobile-Component';
import HeaderUserIconComponent from '../components/Header-User-Icon-Component';
import HeadingComponent from '../components/Heading-Component';
import HeroFloatingImages from '../components/Hero-Floating-Images';
import HeroGeneric from '../components/Hero-Generic';
import HeroParenthesisOffset from '../components/Hero-Parenthesis-Offset';
import HeroParenthesisOpen from '../components/Hero-Parenthesis-Open';
import HeroParenthesisWrapper from '../components/Hero-Parenthesis-Wrapper';
import Hr from '../components/Hr';
import HubSpotForm from '../components/HubSpot-Form';
import IFrameComponent from '../components/IFrame-Component';
import ImageCardComponent from '../components/Image-Card-Component';
import ImageGallery from '../components/Image-Gallery';
import Imccta from '../components/Imc-cta';
import IMCEventDetailComponent from '../components/IMC-Event-Detail-Component';
import InsetContentBlockComponent from '../components/Inset-Content-Block-Component';
import Link from '../components/Link';
import LinktoChannelComponent from '../components/Link-to-Channel-Component';
import ListDisplayControlComponent from '../components/List-Display-Control-Component';
import ListofLinksComponent from '../components/List-Of-Links-Component';
import MarketPlanNavigation from '../components/Market-Plan-Navigation';
import MediaCarouselComponent from '../components/Media-Carousel-Component';
import MeridianMapComponent from '../components/Meridian-Map-Component';
import MPHeaderLinkComponent from '../components/MP-Header-Link-Component';
import MPPageLinkListComponent from '../components/MP-Page-Link-List-Component';
import MyInfoComponent from '../components/My-Info-Component';
import MyInquiriesComponent from '../components/My-Inquiries-Component';
import MySavedSearchesComponent from '../components/My-Saved-Searches-Component';
import NavigationBarComponent from '../components/Navigation-Bar-Component';
import PersonDocument from '../components/Person-Document';
import ProfileComponent from '../components/Profile-Component';
import RecommendedContent from '../components/Recommended-Content';
import RelatedContent from '../components/Related-Content';
import ResultsFilter from '../components/Results-Filter';
import RichTextComponent from '../components/Rich-Text-Component';
import SaveSearches from '../components/Save-Searches';
import SearchBar from '../components/Search-Bar';
import SearchResultsArticlesComponent from '../components/Search-Results-Articles-Component';
import SearchResultsEventsComponent from '../components/Search-Results-Events-Component';
import SearchResultsExhibitorsComponent from '../components/Search-Results-Exhibitors-Component';
import SearchResultsInformationComponent from '../components/Search-Results-Information-Component';
import ShowSpecialsComponent from '../components/Show-Specials-Component';
import SingleLink from '../components/Single-Link';
import SnippetComponent from '../components/Snippet-Component';
import SocialButton from '../components/Social-Button';
import SocialButtonList from '../components/Social-Button-List';
import SocialIconListComponent from '../components/Social-Icon-List-Component';
import SortSearchResults from '../components/Sort-Search-Results';
import StandaloneImageComponent from '../components/Standalone-Image-Component';
import StandaloneVideoComponent from '../components/Standalone-Video-Component';
import StickyBannerComponent from '../components/Sticky-Banner-Component';
import StyleGuideComponent from '../components/Style-Guide-Component';
import Styleguide from '../components/Styleguide';
import SubscribeForm from '../components/Subscribe-Form';
import TabComponent from '../components/Tab-Component';
import TabbedNavigationComponent from '../components/Tabbed-Navigation-Component';
import TableComponent from '../components/Table-Component';
import TagFilter from '../components/Tag-Filter';
import TopHeaderComponent from '../components/Top-Header-Component';
import TypeAheadSearch from '../components/Type-Ahead-Search';
import VerticalTabComponent from '../components/Vertical-Tab-Component';
import VerticalTabbedNavigationComponent from '../components/Vertical-Tabbed-Navigation-Component';
import VideoCardComponent from '../components/Video-Card-Component';
import VideoGallery from '../components/Video-Gallery';
import WelcomeModalWindowComponent from '../components/Welcome-Modal-Window-Component';

const components = new Map();
components.set('Accordion-Component', AccordionComponent);
components.set('Accordion-Module-Component', AccordionModuleComponent);
components.set('Accordion-Section-Component', AccordionSectionComponent);
components.set('Activities-Card-Component', ActivitiesCardComponent);
components.set('Article', Article);
components.set('Article-Card-Component', ArticleCardComponent);
components.set('Article-List', ArticleList);
components.set('Base-Form-Component', BaseFormComponent);
components.set('Basic-Card-Border', BasicCardBorder);
components.set('Basic-Card-Circle', BasicCardCircle);
components.set('Basic-Card-Parenthesis', BasicCardParenthesis);
components.set('Basic-Card-Round-Corners', BasicCardRoundCorners);
components.set('Basic-Parenthesis-Section', BasicParenthesisSection);
components.set('Basic-Pill-Box-Section', BasicPillBoxSection);
components.set('Basic-Single-Column-Component', BasicSingleColumnComponent);
components.set('Basic-Two-Column-Section', BasicTwoColumnSection);
components.set('Breadcrumbs-Component', BreadcrumbsComponent);
components.set('Broadstreet-Ad-Static-Component', BroadstreetAdStaticComponent);
components.set('Building-Navigator-Component', BuildingNavigatorComponent);
components.set('Campus-View-Component', CampusViewComponent);
components.set('Carousel-Component', CarouselComponent);
components.set('Channel-Preference-Center-Component', ChannelPreferenceCenterComponent);
components.set('Channel-Selector-Component', ChannelSelectorComponent);
components.set('Company-Navigation', CompanyNavigation);
components.set('Content-Breaker-Component', ContentBreakerComponent);
components.set('Content-Section-Component', ContentSectionComponent);
components.set('Content-Section-With-Background-Color', ContentSectionWithBackgroundColor);
components.set('Content-Section-With-Image-Background', ContentSectionWithImageBackground);
components.set('Define-Search-Intent', DefineSearchIntent);
components.set('Digital-Catalog', DigitalCatalog);
components.set('Digital-Showroom-Catalogs-List', DigitalShowroomCatalogsList);
components.set('Digital-Showroom-Catalogs-Overview', DigitalShowroomCatalogsOverview);
components.set('Digital-Showroom-Contact-Information', DigitalShowroomContactInformation);
components.set('Digital-Showroom-Events-List', DigitalShowroomEventsList);
components.set('Digital-Showroom-Events-Overview', DigitalShowroomEventsOverview);
components.set('Digital-Showroom-Info', DigitalShowroomInfo);
components.set('Digital-Showroom-Lines-List', DigitalShowroomLinesList);
components.set('Digital-Showroom-Lines-Overview', DigitalShowroomLinesOverview);
components.set('Digital-Showroom-Product-Detail', DigitalShowroomProductDetail);
components.set('Digital-Showroom-Products-List', DigitalShowroomProductsList);
components.set('Digital-Showroom-Products-Overview', DigitalShowroomProductsOverview);
components.set('Digital-Showroom-Specials', DigitalShowroomSpecials);
components.set('Digital-Showroom-Specials-Overview', DigitalShowroomSpecialsOverview);
components.set('Digital-Tab', DigitalTab);
components.set('Digital-Tabbed-Navigation-Component', DigitalTabbedNavigationComponent);
components.set('Dining-Guide', DiningGuide);
components.set('Event-Detail', EventDetail);
components.set('Event-List', EventList);
components.set('Event-Registration-Form-For-IMC-Events', EventRegistrationFormForIMCEvents);
components.set('Exhibited-On-Floor', ExhibitedOnFloor);
components.set('Exhibitor-Ad-Component', ExhibitorAdComponent);
components.set('Exhibitor-AZ-Directory', ExhibitorAZDirectory);
components.set('ExtendedTooltip', ExtendedTooltip);
components.set('Featured-Articles', FeaturedArticles);
components.set('Featured-Events', FeaturedEvents);
components.set('Filter-Bar-Component', FilterBarComponent);
components.set('Filter-Options', FilterOptions);
components.set('Filter-Search-By-Letter', FilterSearchByLetter);
components.set('Flex-Grid', FlexGrid);
components.set('Flex-Section', FlexSection);
components.set('Floor-Plan-Component', FloorPlanComponent);
components.set('Footer-Flags', FooterFlags);
components.set('Footer-Navigation-Component', FooterNavigationComponent);
components.set('Global-Header-Container', GlobalHeaderContainer);
components.set('Grid-Column-Component', GridColumnComponent);
components.set('Grid-Component', GridComponent);
components.set('Header-Navigation-Component', HeaderNavigationComponent);
components.set('Header-Navigation-Mobile-Component', HeaderNavigationMobileComponent);
components.set('Header-User-Icon-Component', HeaderUserIconComponent);
components.set('Heading-Component', HeadingComponent);
components.set('Hero-Floating-Images', HeroFloatingImages);
components.set('Hero-Generic', HeroGeneric);
components.set('Hero-Parenthesis-Offset', HeroParenthesisOffset);
components.set('Hero-Parenthesis-Open', HeroParenthesisOpen);
components.set('Hero-Parenthesis-Wrapper', HeroParenthesisWrapper);
components.set('Hr', Hr);
components.set('HubSpot-Form', HubSpotForm);
components.set('IFrame-Component', IFrameComponent);
components.set('Image-Card-Component', ImageCardComponent);
components.set('Image-Gallery', ImageGallery);
components.set('Imc-cta', Imccta);
components.set('IMC-Event-Detail-Component', IMCEventDetailComponent);
components.set('Inset-Content-Block-Component', InsetContentBlockComponent);
components.set('Link', Link);
components.set('Link-to-Channel-Component', LinktoChannelComponent);
components.set('List-Display-Control-Component', ListDisplayControlComponent);
components.set('List-of-Links-Component', ListofLinksComponent);
components.set('Market-Plan-Navigation', MarketPlanNavigation);
components.set('Media-Carousel-Component', MediaCarouselComponent);
components.set('Meridian-Map-Component', MeridianMapComponent);
components.set('MP-Header-Link-Component', MPHeaderLinkComponent);
components.set('MP-Page-Link-List-Component', MPPageLinkListComponent);
components.set('My-Info-Component', MyInfoComponent);
components.set('My-Inquiries-Component', MyInquiriesComponent);
components.set('My-Saved-Searches-Component', MySavedSearchesComponent);
components.set('Navigation-Bar-Component', NavigationBarComponent);
components.set('Person-Document', PersonDocument);
components.set('Profile-Component', ProfileComponent);
components.set('Recommended-Content', RecommendedContent);
components.set('Related-Content', RelatedContent);
components.set('Results-Filter', ResultsFilter);
components.set('Rich-Text-Component', RichTextComponent);
components.set('Save-Searches', SaveSearches);
components.set('Search-Bar', SearchBar);
components.set('Search-Results-Articles-Component', SearchResultsArticlesComponent);
components.set('Search-Results-Events-Component', SearchResultsEventsComponent);
components.set('Search-Results-Exhibitors-Component', SearchResultsExhibitorsComponent);
components.set('Search-Results-Information-Component', SearchResultsInformationComponent);
components.set('Show-Specials-Component', ShowSpecialsComponent);
components.set('Single-Link', SingleLink);
components.set('Snippet-Component', SnippetComponent);
components.set('Social-Button', SocialButton);
components.set('Social-Button-List', SocialButtonList);
components.set('Social-Icon-List-Component', SocialIconListComponent);
components.set('Sort-Search-Results', SortSearchResults);
components.set('Standalone-Image-Component', StandaloneImageComponent);
components.set('Standalone-Video-Component', StandaloneVideoComponent);
components.set('Sticky-Banner-Component', StickyBannerComponent);
components.set('Style-Guide-Component', StyleGuideComponent);
components.set('Styleguide', Styleguide);
components.set('Subscribe-Form', SubscribeForm);
components.set('Tab-Component', TabComponent);
components.set('Tabbed-Navigation-Component', TabbedNavigationComponent);
components.set('Table-Component', TableComponent);
components.set('Tag-Filter', TagFilter);
components.set('Top-Header-Component', TopHeaderComponent);
components.set('Type-Ahead-Search', TypeAheadSearch);
components.set('Vertical-Tab-Component', VerticalTabComponent);
components.set('Vertical-Tabbed-Navigation-Component', VerticalTabbedNavigationComponent);
components.set('Video-Card-Component', VideoCardComponent);
components.set('Video-Gallery', VideoGallery);
components.set('Welcome-Modal-Window-Component', WelcomeModalWindowComponent);

export default function componentFactory(componentName) {
  return components.get(componentName);
};
